import { Box, BoxProps } from '@mui/material';
import React from 'react';

type ProfileDescriptionProps = {
    children?: string | TrustedHTML | null;
} & Omit<BoxProps, 'dangerouslySetInnerHTML'>;

export function ProfileDescription({
    children,
    ...props
}: ProfileDescriptionProps) {
    if (!children) {
        return null;
    }

    return (
        <Box
            sx={{
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '32px',
            }}
            dangerouslySetInnerHTML={{ __html: children }}
            {...props}
        />
    );
}
